import React from 'react';

// Animasi hanya memakai transform + opacity (tanpa filter) agar mulus di iOS Safari.
// Gaya yang sama dipakai pre-loader di index.html; ubah keduanya bersamaan.
const loaderStyles = `
  .mias-loader { min-height: 100vh; display: flex; flex-direction: column; align-items: center; justify-content: center; background: radial-gradient(circle at 50% 42%, #ffffff 0%, #f6f8f6 55%); }
  .mias-loader__stage { position: relative; width: 200px; height: 200px; display: flex; align-items: center; justify-content: center; }
  .mias-loader__halo { position: absolute; inset: 22px; border-radius: 9999px; background: radial-gradient(circle, rgba(25,230,94,0.16) 0%, rgba(25,230,94,0) 70%); animation: miasHalo 3.2s ease-in-out infinite; }
  .mias-loader__ring { position: absolute; inset: 0; animation: miasSpin 2.4s linear infinite; }
  .mias-loader__ring--slow { animation-duration: 6s; animation-direction: reverse; }
  .mias-loader__card { position: relative; width: 124px; height: 124px; animation: miasFloat 3.2s ease-in-out infinite; }
  .mias-loader__card img { width: 100%; height: 100%; object-fit: contain; display: block; }
  .mias-loader__text { margin-top: 28px; font-size: 14px; line-height: 1.5; color: #4b5563; font-weight: 500; text-align: center; max-width: 300px; padding: 0 16px; }
  .mias-loader__dots { display: inline-flex; gap: 4px; margin-left: 6px; vertical-align: middle; }
  .mias-loader__dots span { width: 4px; height: 4px; border-radius: 9999px; background: #16a34a; animation: miasDot 1.4s ease-in-out infinite; }
  .mias-loader__dots span:nth-child(2) { animation-delay: 0.2s; }
  .mias-loader__dots span:nth-child(3) { animation-delay: 0.4s; }
  @keyframes miasSpin { to { transform: rotate(360deg); } }
  @keyframes miasFloat { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-6px); } }
  @keyframes miasHalo { 0%, 100% { transform: scale(0.92); opacity: 0.7; } 50% { transform: scale(1.06); opacity: 1; } }
  @keyframes miasDot { 0%, 80%, 100% { opacity: 0.25; transform: translateY(0); } 40% { opacity: 1; transform: translateY(-3px); } }
  @media (prefers-reduced-motion: reduce) {
    .mias-loader *, .mias-loader *::before { animation-duration: 0s !important; animation-iteration-count: 1 !important; }
  }
`;

export const LoadingSpinner: React.FC = () => {
  return (
    <div className="mias-loader">
      <style>{loaderStyles}</style>
      <div className="mias-loader__stage">
        <div className="mias-loader__halo" />
        <svg className="mias-loader__ring mias-loader__ring--slow" viewBox="0 0 200 200" aria-hidden="true">
          <circle cx="100" cy="100" r="92" fill="none" stroke="#16a34a" strokeOpacity="0.18" strokeWidth="1" strokeDasharray="2 10" strokeLinecap="round" />
        </svg>
        <svg className="mias-loader__ring" viewBox="0 0 200 200" aria-hidden="true">
          <defs>
            <linearGradient id="miasArc" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor="#19e65e" stopOpacity="0" />
              <stop offset="100%" stopColor="#16a34a" />
            </linearGradient>
          </defs>
          <circle cx="100" cy="100" r="80" fill="none" stroke="#e5ece7" strokeWidth="2" />
          <circle cx="100" cy="100" r="80" fill="none" stroke="url(#miasArc)" strokeWidth="2.5" strokeLinecap="round" strokeDasharray="150 353" />
        </svg>
        <div className="mias-loader__card">
          <img src="/logo-transparan.png" alt="Logo" />
        </div>
      </div>
      <p className="mias-loader__text">
        Harap Tunggu, kami sedang menyiapkan Dashboard antum
        <span className="mias-loader__dots" aria-hidden="true"><span /><span /><span /></span>
      </p>
    </div>
  );
};
